import React from 'react';
import {
    ColumnPickerModal,
    PickableItem,
} from '@instinet-analytics/semantic-ui-components';

import { useDispatchUpdateVisibleColumns } from 'widgets/store/grid/visibleColumns/dispatcher';
import {
    SymbolEventColumn,
    corporateActionsColumnDefinitions,
} from 'widgets/corpActions/widget/grid/columnDefinitions';
import { initialCorporateActionsConfiguration } from 'widgets/corpActions/widget/store/config/CorporateActionsWidgetConfigState';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

export interface CorporateActionColumnPickerProps {
    visibleColumns: SymbolEventColumn[];
}

export default function CorporateActionColumnPicker(
    props: CorporateActionColumnPickerProps
) {
    const { visibleColumns } = props;

    const { editedColumnNames } = useWidgetEditedColumnNames();

    const allPickableItems: PickableItem<SymbolEventColumn>[] =
        corporateActionsColumnDefinitions.map((column) => ({
            value: column.field as SymbolEventColumn,
            name:
                (editedColumnNames ?? [])[column.field] ||
                column.name ||
                column.field!,
            nameSuffix: (editedColumnNames ?? [])[column.field]
                ? column.name || column.field!
                : undefined,
            tag: column.tag,
        }));

    const dispatchUpdateVisibleColumns = useDispatchUpdateVisibleColumns();

    const onUpdateVisibleColumns = (cols: SymbolEventColumn[]) => {
        dispatchUpdateVisibleColumns(cols);
    };

    return (
        <ColumnPickerModal
            selectedValues={visibleColumns}
            defaultSelectedValues={
                initialCorporateActionsConfiguration.visibleColumns
            }
            allItems={allPickableItems}
            withoutDescriptions={true}
            onUpdateSelectedValues={onUpdateVisibleColumns}
        />
    );
}
